
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/faker-mode.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-faker-mode-demo-basic","docs-power-design-faker-mode-demo-user-switch","docs-power-design-faker-mode-demo-faker-iam-basic"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/faker-mode.md?type=demo')
};